// resources/js/src/components/community/stories/StoryTray.tsx

import React, { useState } from "react";
import { StoryGroup } from "../interfaces/storyTypes";
import { useAuthStore } from "../../../../../auth/auth.store";
import CreateStoryButton from "./CreateStoryButton";
import StoryItem from "./StoryItem";
import StoryModal from "./StoryModal";
import StoryPreviewModal from "./StoryPreviewModal";

interface Props {
  groups: StoryGroup[];
}

const StoryTray: React.FC<Props> = ({ groups }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  const [viewerOpen, setViewerOpen] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [groupIndex, setGroupIndex] = useState(0);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [caption, setCaption] = useState("");

  const safeGroups = Array.isArray(groups) ? groups : [];

  const openGroup = (index: number) => {
    setGroupIndex(index);
    setViewerOpen(true);
    // StoryModal هيعمل markSeen لما يفتح أول ستوري
  };

  const handleFileSelect = (file: File) => {
    if (!isAuthenticated) return;
    setSelectedFile(file);
    setPreviewOpen(true);
  };

  return (
    <>
      <div className="flex space-x-3 overflow-x-auto p-3 max-w-4xl mx-auto">
        {isAuthenticated && (
          <CreateStoryButton onFileSelect={handleFileSelect} />
        )}

        {safeGroups.map((group, index) => (
          <StoryItem
            key={group.userId}
            username={group.author.name}
            profilePic={group.author.avatarUrl}
            seen={group.allSeen}
            onClick={() => openGroup(index)}
          />
        ))}
      </div>

      <StoryModal
        isOpen={viewerOpen}
        groups={safeGroups}
        groupIndex={groupIndex}
        onNavigateGroup={setGroupIndex}
        onClose={() => setViewerOpen(false)}
      />

      <StoryPreviewModal
        isOpen={previewOpen}
        file={selectedFile}
        caption={caption}
        setCaption={setCaption}
        onClose={() => {
          setPreviewOpen(false);
          setSelectedFile(null);
        }}
        onPosted={() => {
          setPreviewOpen(false);
          setSelectedFile(null);
        }}
      />
    </>
  );
};

export default StoryTray;